
import { useMemo } from 'react';
import moment from 'moment';
import { DEFAULT_REQUEST_FORMAT, OPERATORS } from 'components/AgGrid/helpers/filterHelpers';

export const useSubmitAgModel = ({ conditions, operator }) => {
  return useMemo(() => {
    const modifiedConditions = conditions.map(({ dateFrom, dateTo, type }) => {
      const condition = {
        type,
        dateFrom: moment(dateFrom).format(DEFAULT_REQUEST_FORMAT),
        dateTo: dateTo ? moment(dateTo).format(DEFAULT_REQUEST_FORMAT) : null,
        filterType: 'date',
      };

      if (type === OPERATORS.withInYear) {
        condition.dateFrom = moment(dateFrom).startOf('year').format(DEFAULT_REQUEST_FORMAT);
        condition.dateTo = moment(dateFrom).endOf('year').format(DEFAULT_REQUEST_FORMAT);
      }

      if (type === OPERATORS.withInMonth) {
        condition.dateFrom = moment(dateFrom).startOf('month').format(DEFAULT_REQUEST_FORMAT);
        condition.dateTo = moment(dateFrom).endOf('month').format(DEFAULT_REQUEST_FORMAT);
      }

      return condition;
    });

    const isWithOperator = conditions.every(({ dateFrom }) => !!dateFrom);
    if (isWithOperator) {
      return {
        conditions: modifiedConditions,
        operator: operator.toUpperCase(),
        filterType: 'date',
      };
    }

    return {
      ...modifiedConditions[0],
      filterType: 'date',
    };
  }, [conditions, operator]);
};
